'use strict';

var profileModule = angular.module('t2g.profile', [
  'gettext',
  'ngFileUpload',
  'ui.router',
  require('t2g.common.data-access.countryConfig').name,
  require('t2g.common.services.geoCodeService').name,
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
  require('t2g.common.services.RESTService').name,
]);

module.exports = profileModule;

profileModule.controller('ProfileCtrl', require('./profileCtrl'));

profileModule.config(function($stateProvider) {
  $stateProvider.state('private.main.profile', {
    url: '/profile',
    title: 'Profile',
    templateUrl: '/app/modules/profile/ProfileView.html?v=4.5.6',
    controller: 'ProfileCtrl',
    resolve: {
      officeResolve: function(OfficeDA) {
        return OfficeDA.get();
      },
      industryResolve: function($q, Industry) {
        var deffered = $q.defer();

        Industry.query({}, function(response) {
          if (response instanceof Array) {
            deffered.resolve(response);
          } else {
            deffered.reject();
          }
        });

        return deffered.promise;
      },
      countryResolve: function(CountryConfig) {
        return CountryConfig.getCountries();
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/app/modules/profile/profileModule.js